// -*-mode: rjsx -*-
import React, { Component } from "react"
import PropTypes from "prop-types"
// eslint-disable-next-line
import clsx from "clsx"
// eslint-disable-next-line
import { makeStyles, withStyles } from "@material-ui/core/styles"

import grey from "@material-ui/core/colors/grey"
// eslint-disable-next-line
import red from "@material-ui/core/colors/red"
// eslint-disable-next-line
import green from "@material-ui/core/colors/green"

import DeleteIcon from "@material-ui/icons/DeleteOutline"

// LOGGING SETUP
import appConfig from "./../../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<FlashSwipeItem>")

const styles = theme => ({
    listItem: {
        transition: "transform 0.5s ease-out",
        width: "100%",
        alignItems: "center",
//        boxSizing: "border-box",
//        backgroundColor: red[400],
//        height: "100%",
        display: "flex",

        [theme.breakpoints.up("md")]: {
            padding: 2, // just enought for shadows to show up
        },
        
    },
    
    wrapper: {
        position: "relative",
        transition: "max-height 0.5s ease,margin 1s ease",
        maxHeight: "1000px",
//        transformOrigin: "top",
        overflow: "hidden",
        width: "100%",
        //        backgroundColor: grey[800], // this actually shows up and background

        [theme.breakpoints.up("md")]: {
            marginTop: 5, // just enought for shadows to show up
            marginBottom: 10, // just enought for shadows to show up
        },
    },


    backgroundDiv: {
        position: "absolute",
        color: "white",
        backgroundColor: grey[200],
        width: "100%",
        height: "100%",
        zIndex: -1,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderRadius: 6,
    },

    deleteIcon: {
        color: grey[800],
        fontSize: 35,
        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            fontSize: 35,
            color: grey[800]
        },
    },

})

class FlashSwipeItem extends Component {
    // DOM Refs
    listElement
    wrapper
    background

    // Drag & Drop
    dragStartX = 0;
    offset = 0;
    dragged = false;

    // FPS Limit
    startTime;
    fpsInterval = 1000 / 60;
    // fpsInterval = 1000 / 200

    constructor(props) {
        super(props);

        this.listElement = null;
        this.wrapper = null;
        this.background = null;

        this.leftDiv = null;
        this.rightDiv = null;

        this.onMouseMove = this.onMouseMove.bind(this);
        this.onTouchMove = this.onTouchMove.bind(this);
        this.onDragStartMouse = this.onDragStartMouse.bind(this);
        this.onDragStartTouch = this.onDragStartTouch.bind(this);
        this.onDragEndMouse = this.onDragEndMouse.bind(this);
        this.onDragEndTouch = this.onDragEndTouch.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);
        this.updatePosition = this.updatePosition.bind(this);
        this.onClicked = this.onClicked.bind(this);

        this.onSwiped = this.onSwiped.bind(this);
    }

    componentDidMount() {
        window.addEventListener("mouseup", this.onDragEndMouse);
        window.addEventListener("touchend", this.onDragEndTouch);
    }

    componentWillUnmount() {
        window.removeEventListener("mouseup", this.onDragEndMouse);
        window.removeEventListener("touchend", this.onDragEndTouch);
    }

    onDragStartMouse(evt) {
        this.onDragStart(evt.clientX);
        window.addEventListener("mousemove", this.onMouseMove);
    }

    onDragStartTouch(evt) {
        const touch = evt.targetTouches[0];
        this.onDragStart(touch.clientX);
        window.addEventListener("touchmove", this.onTouchMove);
    }

    onDragStart(clientX) {
        this.dragged = true;
        this.dragStartX = clientX;
//        this.listElement.className = "ListItem";
        this.startTime = Date.now();
        requestAnimationFrame(this.updatePosition);
    }

    onDragEndMouse(evt) {
        window.removeEventListener("mousemove", this.onMouseMove);
        this.onDragEnd();
    }

    onDragEndTouch(evt) {
        window.removeEventListener("touchmove", this.onTouchMove);
        this.onDragEnd();
    }

    onDragEnd() {
        
        // eslint-disable-next-line
        const { classes } = this.props
        
        if (this.dragged) {
            this.dragged = false

            // TODO: threshhold
            // const threshold = this.props.threshold || 0.5 // percentage
            // percentage, also makes movement faster for some reason            
            const threshold = this.props.threshold || 0.3  // was default

            // this is the width of the whole content
            log.trace("this.listElement.offsetWidth = ", this.listElement.offsetWidth)
            log.trace("threshnold = ", threshold)
            log.trace("this.offset = ", this.offset)
            
            if (this.offset < this.listElement.offsetWidth * threshold * -1) {
                // swipe to the offset
                this.offset = -this.listElement.offsetWidth * 2;
                this.wrapper.style.maxHeight = 0;
                this.wrapper.style.margin = 0
                this.onSwiped();
            } else if(this.offset > this.listElement.offsetWidth * threshold) {
                this.offset = this.listElement.offsetWidth * 2;
                this.wrapper.style.maxHeight = 0;
                this.wrapper.style.margin = 0
                this.onSwiped();
            }  else {
                this.offset = 0
//                this.leftDiv.style.opacity = 0
//                this.rightDiv.style.opacity = 0
//                this.leftDiv.style.transform = "opacity 1s ease"
//                this.rightDiv.style.transform = "opacity 1s ease"
            }

            // this.listElement.className = "BouncingListItem";
            // cdmitri: makes it "slide back" slowly
//            this.listElement.className=classes.bouncingListItem
            this.listElement.style.transform = `translateX(${this.offset}px)` // next: fire even on and of transition
        }
    }

    onMouseMove(evt) {
        const offset = evt.clientX - this.dragStartX;
        // NOTES: this limits to offset only swipe
        //if (offset < 0) {
        //    this.offset = offset;
        //}

        this.offset = offset
    }

    onTouchMove(evt) {
        const touch = evt.targetTouches[0];
        const offset = touch.clientX - this.dragStartX;
        // NOTES: this limits to offset only swipe
        // if (offset < 0) {
        //    this.offset = offset;
        // }
        this.offset = offset
    }

    updatePosition() {
        if (this.dragged) requestAnimationFrame(this.updatePosition);

        const now = Date.now();
        const elapsed = now - this.startTime;

        if (this.dragged && elapsed > this.fpsInterval) {
            this.listElement.style.transform = `translateX(${this.offset}px)`;

            /*
            const opacity = (Math.abs(this.offset) / 100).toFixed(2);
            if (opacity < 1 && opacity.toString() !== this.background.style.opacity) {
                this.background.style.opacity = opacity.toString();
            }
            if (opacity >= 1) {
                this.background.style.opacity = "1";
            }
            */

            if(this.offset > 0) {
                this.leftDiv.style.opacity = 1
                this.rightDiv.style.opacity = 0
            } else if(this.offset < 0) {
                this.rightDiv.style.opacity = 1
                this.leftDiv.style.opacity = 0
            }

            this.startTime = Date.now();
        }
    }

    onClicked() {
//        if (this.props.onSwipe) {
//            this.props.onSwipe();
//        }
    }

    onSwiped() {
        log.debug("onSwiped()")
        if (this.props.onSwipe) {
            // log.debug("onSwiped(): this.props.onSwipe =", this.props.onSwipe)
            this.props.onSwipe("delete")
        }
    }

    render() {

        const { classes, children } = this.props


        return (
              <div
                className={classes.wrapper}
                style={{zIndex: 500}}
                ref={div => (this.wrapper = div)}>

                <div className={classes.backgroundDiv}>
                  <DeleteIcon className={classes.deleteIcon} style={{opacity: 0, marginLeft: 30}} ref={div => (this.leftDiv = div)}/>
                  <DeleteIcon className={classes.deleteIcon} style={{opacity: 0, marginRight: 30}} ref={div => (this.rightDiv = div)}/>
                </div>

                <div
                  className={classes.listItem}                  
                  onClick={this.onClicked}
                  ref={div => (this.listElement = div)}
                  onMouseDown={this.onDragStartMouse}
                  onTouchStart={this.onDragStartTouch}>
                  {children}
                </div>


              </div>
        )
    }
}

FlashSwipeItem.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles, { name: "FlashSwipeItem" })(FlashSwipeItem)


